<template>
  <div class="tour-sub-title font-semibold">
    <div class="tour-sub-title__divided u-text-secondary">
      <button-icon
        class="tour-sub-title__count"
        :class="{ _active: !!count }"
        @click="onShowReviews"
      >
        <template #before>
          <rating-stars
            :value="reviews.rating"
            tag="span"
            class="tour-sub-title__stars"
          />
        </template>
        <template v-if="count">
          <span class="u-text-green-hover">{{ rating }}</span>
        </template>
        (<span class="tour-sub-title__count-text u-text-secondary"
          >{{ $tc("reviews.reviews", count) }}</span
        >)
      </button-icon>
      <divider-dot />
      <span class="u-text-secondary">{{
        $tc("common.days", days.length)
      }}</span>

        <Awards
          class="tour-sub-title__awards"
          v-if="getAwards"
          :name="getAwards.name"
          :code="getAwards.code"
          :icon="getAwards.icon"
        />

    </div>
  </div>
</template>

<script>
import getRating from "@/assets/js/utils/get-rating";
import ButtonIcon from "@/components/ui-kit/button-icon/index.vue";
import RatingStars from "@/components/ui-kit/rating-stars/index.vue";
import DividerDot from "@/components/ui-kit/divider-dot/index.vue";
import Awards from "@/components/ui-kit/awards/index.vue";

export default {
  components: {
    ButtonIcon,
    RatingStars,
    Awards,
    DividerDot,
  },
  props: {
    awards: {
      type: Object,
    },
    reviews: {
      type: Object,
      required: true,
    },
    days: {
      type: Array,
      required: true,
    },
  },
  computed: {
    rating() {
      return getRating(this.reviews.rating);
    },
    count() {
      return this.reviews.count_total || 0;
    },
    getAwards() {
      return this.awards.code === 'best_tour' ? this.awards : false;
    },
  },
  methods: {
    onShowReviews() {
      if (this.count) {
        this.$emit("show-reviews");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".tour-sub-title";

#{$b} {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > *:not(:last-child),
  #{$b}__divided > *:not(:last-child) {
    margin-right: 6px;
  }

  &__stars {
    margin-right: 2px;
  }

  &__count {
    &:not(._active) {
      @include mixin.decor();
    }

    &._active {
      #{$b}__count-text {
        text-decoration: underline;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  &__divided {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    @media (min-width: 528px) {
      flex-wrap: nowrap;
    }
  }
  &__awards{
    margin: 12px 0;
    @media (min-width: 528px) {
      margin: 0 8px;
    }
  }
}
</style>
